/**
 * Конфигурация моковых данных для разработки
 * 
 * Включает/выключает использование моковых данных вместо реальной авторизации.
 * Установите VITE_ENABLE_MOCK_AUTH=true в .env для разработки без Telegram.
 */

/**
 * Включить моковую авторизацию
 * 
 * Установите VITE_ENABLE_MOCK_AUTH=true в .env для разработки без Telegram Web App SDK.
 * В production всегда должно быть false.
 */
export const ENABLE_MOCK_AUTH = import.meta.env.VITE_ENABLE_MOCK_AUTH === 'true'

/**
 * Моковые данные пользователя
 */
export const MOCK_USER = {
  id: 123456789,
  firstName: 'Тестовый',
  lastName: 'Пользователь',
  username: 'test_user',
  photoUrl: null,
  languageCode: 'ru',
  isPremium: false,
  lastSeenAt: null,
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
}

/**
 * Моковая initData строка
 * Используется для имитации Telegram initData в режиме разработки
 */
export const MOCK_INIT_DATA = 'mock_init_data_for_development'

/**
 * Моковые данные для Telegram Web App SDK
 * Используется через createMockTelegramWebApp из mock-telegram.ts
 */

